let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5TvQa")).then(() => parcelRequire('lEtgt'));